import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, ElementRef, EventEmitter, HostListener, Inject, Input, OnInit, Output, SecurityContext, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ModalDismissReasons, NgbDropdown, NgbDropdownConfig, NgbDropdownModule, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { map, take, takeUntil } from 'rxjs';
import { LoginModel } from 'src/app/models/legacy';
import { ChangePasswordPopupComponent } from 'src/app/popups/change-password-popup/change-password-popup.component';

import { AuthService } from 'src/app/services/auth.service';
import { Helper } from 'src/app/utils/helper/helper';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { EventsEmitter } from '../event-emitter/EventEmitter';
import { SaleAdminNotificationSettingPopupComponent } from 'src/app/settings/sale-admin-notification-setting-popup/sale-admin-notification-setting-popup.component';
import { SignalRNotificationService } from '../../services/singnalr-notification.service';

@Component({
  selector: 'top-banner',
  templateUrl: './top-banner.component.html',
  styleUrls: ['./top-banner.component.scss'],
  standalone: true,
  imports: [CommonModule, NgbModule, NgbDropdownModule],
  providers: [Helper],
})
export class TopBannerComponent extends BaseUnsubscribeComponent implements OnInit {
  isExpanded: boolean;
  @Input() isSideBarOpen: boolean = false;

  @Output() public readonly isSideBarOpenEvent = new EventEmitter();

  public user: LoginModel;
  public isLoginStatus: boolean;

  public popupComponent: any;
  public screenHeight;
  public screenWidth;
  public isMobileScreen: boolean = false;

  public helper: Helper;
  public IsSalesCompany: boolean = false;
  public IsVet: boolean = false;
  public IsAdmin: boolean = false;
  public closeResult = '';
  public imageUrl: string;
  autoClose: NgbDropdown['autoClose'] = 'inside';
  @ViewChild('userProfileMenuDropdown') userProfileMenuDropdown: NgbDropdown;
  unreadCount$ = this.notify.unreadCount$;

  unreadNotifications$ = this.notify.notifications$.pipe(
    map(list => list)
  );

  constructor(
    public readonly authService: AuthService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    @Inject(DOCUMENT) private readonly document: Document,
    helper: Helper,
    private readonly modalService: NgbModal,
    private readonly eventEmitter: EventsEmitter,
    private readonly config: NgbDropdownConfig,
    private readonly elementRef: ElementRef,
    private notify: SignalRNotificationService
  ) {
    super();
    this.helper = helper;
    this.helper.popupResponse$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((response) => {
        if (response && response.key) {
          this.popupResponse(response.key, response?.fromPage);
        }
      });

    this.screenWidth = window.innerWidth;
    this.screenHeight = window.innerHeight;
    if (this.screenWidth < 567) {
      this.isMobileScreen = true;
      config.placement = 'left-top';
    }
    const that = this;
  }

  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      if (this.userProfileMenuDropdown) {
        this.userProfileMenuDropdown.close();
      }
    }
  }
  openNotification(n: any) {
    // Mark as read
    this.notify.openNotificationDetail(n);
  }
  dismiss(n: any, event: MouseEvent) {
    event.stopPropagation();
    event.preventDefault();
    this.notify.remove(n);
  }
  markAllRead() {
    //this.notify.markAllRead();
  }
  openChangePasswordPopup() {

    const modalRef = this.modalService.open(ChangePasswordPopupComponent, {
      ariaLabelledBy: 'Change-password-Id',
      centered: true,
      size: 'md',
      keyboard: false,
      backdrop: 'static'
    });

    modalRef.componentInstance.data = { user: this.user };
    modalRef.result.then(
      result => {
        const data = JSON.parse(result);
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  openSaleAdminPopup() {

    const modalRef = this.modalService.open(SaleAdminNotificationSettingPopupComponent, {
      ariaLabelledBy: 'sale-admin-notification-id',
      centered: true,
      size: 'lg',
      keyboard: false,
      backdrop: 'static'
    });

    modalRef.componentInstance.data = { user: this.user };
    modalRef.result.then(
      result => {
        const data = JSON.parse(result);
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  redirectToVetNotificationSettings() {

    this.router.navigate(['/vet-notification-settings']);
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  public logout() {
    this.authService.logout().pipe(take(1)).subscribe((response) => {
      location.href = '/';
    })
  }
  
  public redirectToSettings(): void {
    this.router.navigate(['/settings']);
  }
  
  public RedirectUserManagement(): void {
    this.router.navigate(['/users']);
  }


  public openUserProfilePage(): void {
    this.router.navigate(['/profile/user']);
    return;    
  }
  public openMemberProfilePage(): void {
    
    if (this.authService.IsSalesCompany()) {
      this.router.navigate(['/profile/sales-company']);

      return;

    }
    if (this.authService.IsVet()) {
      this.router.navigate(['/profile/vet']);
      return;
    }
  }

  public openPopup(key: string, inputData: string = null): void {
    let popupSize = 'md';

    const popupOptions = {
      ariaLabelledBy: key + 'Id',
      centered: true,
      //size: popupSize,
      keyboard: false,
      backdrop: 'static',
      windowClass: 'modalWindow_' + key,
    };

    this.helper.openPopupService(popupOptions, this.popupComponent, inputData);
  }

  public popupResponse(key: string, fromPage: string = null): void {
    if (key === 'vet-user-profile') {
      this.openPopup(key, 'header');
    }
  }

  ngOnInit(): void {

    this.userAuthenticate();
    //this.imageUrl = this.authService.getUserImage();
    this.authService.userImage$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(image => {
        this.imageUrl = image;
      });
    this.IsSalesCompany = this.authService.IsSalesCompany();
    this.IsVet = this.authService.IsVet();
    this.IsAdmin = this.authService.getUserTokenResponse()?.isAdmin;

    this.eventEmitter.topBannerEvent.pipe(takeUntil(this.unsubscribe$)).subscribe((response) => {
      this.imageUrl = response.image;
      this.authService.setUserImage(response.image);
    });
    //this.toggleActivityFeedCondition();
  }

  toggleActivityFeedCondition(): void {

  }

  public isSideBarOpenFunction() {

    if (this.isSideBarOpen) {
      this.isSideBarOpenEvent.emit({ isSideBarOpen: false });
      return;
    }

    this.isSideBarOpenEvent.emit({ isSideBarOpen: true });
    return;
  }

  public userAuthenticate(): void {
    this.isLoginStatus = this.authService.isAuthenticated();
    this.authService.userData$.pipe(takeUntil(this.unsubscribe$)).subscribe(data => {
      if (data) {
        this.user = data;
      }
    });
  }

}
